"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.GetSingleBookingWithoutContext = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _format = require("date-fns/format");
var _reactIntl = require("react-intl");
var _Text = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Text"));
var _GetSingleBooking = _interopRequireDefault(require("../screens/GetSingleBooking"));
var _createSimpleToken = _interopRequireDefault(require("../../mutations/createSimpleToken"));
var validators = _interopRequireWildcard(require("../../../../services/input/validators"));
var _events = require("../../consts/events");
var _context = require("../../../../services/log/context");
var _errors = _interopRequireDefault(require("../../../../consts/errors"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
class GetSingleBookingWithoutContext extends React.Component {
  constructor() {
    super(...arguments);
    (0, _defineProperty2.default)(this, "state", {
      error: null,
      submitted: false,
      bookingId: "",
      bookingIdError: null,
      email: "",
      emailError: null,
      departureDate: null,
      departureDateError: null,
      IATA: "",
      IATAError: null
    });
    (0, _defineProperty2.default)(this, "handleBookingId", ev => {
      const {
        value
      } = ev.target;
      const {
        submitted
      } = this.state;
      this.setState({
        bookingId: value,
        bookingIdError: submitted ? validators.required(value) : null
      });
    });
    (0, _defineProperty2.default)(this, "handleEmail", ev => {
      const {
        value
      } = ev.target;
      const {
        submitted
      } = this.state;
      this.setState({
        email: value,
        emailError: submitted ? validators.email(value) : null
      });
    });
    (0, _defineProperty2.default)(this, "handleDepartureDate", departureDate => {
      const {
        submitted
      } = this.state;
      this.setState({
        departureDate,
        departureDateError: submitted ? validators.required(departureDate) : null
      });
    });
    (0, _defineProperty2.default)(this, "handleIATA", value => {
      const {
        submitted
      } = this.state;
      this.setState({
        IATA: value,
        IATAError: submitted ? validators.iata(value) : null
      });
    });
    (0, _defineProperty2.default)(this, "handleSimpleToken", payload => {
      const {
        onGetSimpleToken,
        onFulfill
      } = this.props;
      onFulfill();
      if (onGetSimpleToken) {
        onGetSimpleToken(payload);
        return;
      }
      window.location.href = `${window.location.origin}/manage/${payload.bid}/${payload.token}`;
    });
    (0, _defineProperty2.default)(this, "handleSubmit", ev => {
      ev.preventDefault();
      const {
        log
      } = this.props;
      const {
        bookingId,
        email,
        departureDate,
        IATA
      } = this.state;
      const bookingIdError = validators.required(bookingId);
      const emailError = validators.email(email);
      const departureDateError = validators.required(departureDate);
      const IATAError = validators.iata(IATA);
      const bid = Number(bookingId);
      this.setState({
        bookingIdError,
        emailError,
        departureDateError,
        IATAError,
        submitted: true,
        error: null
      });
      if (IATAError || emailError || bookingIdError || departureDateError) {
        return;
      }
      const date = departureDate ? (0, _format.format)(departureDate, "dd/MM/yyyy") : "";
      const input = {
        email,
        bookingId: bid,
        origin: {
          iataCode: IATA,
          dateOfDeparture: date
        }
      };
      (0, _createSimpleToken.default)(input).then(res => {
        if ("token" in res) {
          log(_events.SIMPLE_TOKEN_RETRIEVED, {});
          this.handleSimpleToken({
            type: "token",
            bid,
            token: res.token
          });
          return;
        }
        const errorType = res.error;
        const error = errorType === "NOT_FOUND" ? _errors.default.incorrectBidIATAInput : _errors.default.general;
        log(_events.LOGIN_STEP_FAILED, {
          operation: "createSimpleToken",
          error: errorType,
          message: res.message
        });
        this.setState({
          error
        });
      }).catch(err => {
        log(_events.CRITICAL_LOGIN_ERROR, {
          operation: "createSimpleToken",
          error: String(err)
        });
        this.setState({
          error: _errors.default.general
        });
      });
    });
  }
  render() {
    const {
      onBack
    } = this.props;
    const {
      bookingId,
      email,
      departureDate,
      IATA,
      emailError,
      IATAError,
      departureDateError,
      bookingIdError,
      error
    } = this.state;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_GetSingleBooking.default, {
      bookingId: bookingId,
      bookingIdError: bookingIdError,
      IATA: IATA,
      IATAError: IATAError,
      email: email,
      emailError: emailError,
      departureDate: departureDate,
      departureDateError: departureDateError,
      error: error && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
          ...error
        })
      }),
      onIATAChange: this.handleIATA,
      onEmailChange: this.handleEmail,
      onBookingIdChange: this.handleBookingId,
      onDepartureDateChange: this.handleDepartureDate,
      onBack: onBack,
      onSubmit: this.handleSubmit
    });
  }
}
exports.GetSingleBookingWithoutContext = GetSingleBookingWithoutContext;
const GetSingleBooking = props => {
  const {
    log
  } = (0, _context.useLog)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(GetSingleBookingWithoutContext, {
    ...props,
    log: log
  });
};
var _default = exports.default = GetSingleBooking;